import React from 'react';
import PropTypes from 'prop-types';
import FieldTitle from 'components/aor/FieldTitle';
import TextField from 'material-ui/TextField/TextField';

const TextFilter = (props) => {
    const {
        input,
        label,
        meta: {
            touched,
            error,
        },
        options,
    } = props;

    const handleBlur = (eventOrValue) => {
        input.onBlur(eventOrValue);
    };

    const handleFocus = (event) => {
        input.onFocus(event);
    };

    const handleChange = (eventOrValue) => {
        input.onChange(eventOrValue);
    };

    return (
        <TextField
            errorText={ touched && error }
            onBlur={ handleBlur }
            onChange={ handleChange }
            onFocus={ handleFocus }
            type='text'
            floatingLabelText={ label ? <FieldTitle
                label={ label }
                source={ 'source' }
                resource={ 'resource' }
            /> : '' }
            value={ input.value }
            name={ input.name }
            { ...options }
        />
    );
};

TextFilter.propTypes = {
    input: PropTypes.object,
    label: PropTypes.string,
    meta: PropTypes.object,
    name: PropTypes.string,
    options: PropTypes.object,
    resource: PropTypes.string,
    source: PropTypes.string,
    validate: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.arrayOf(PropTypes.func),
    ]),
};

export default TextFilter;



// WEBPACK FOOTER //
// ./src/components/list/Filters/types/TextFilter.js